export default __webpack_public_path__ + "static/media/283.a83d5899.jpg";